import { render, staticRenderFns } from "./move-file.vue?vue&type=template&id=f158c174&scoped=true"
import script from "./move-file.vue?vue&type=script&lang=js"
export * from "./move-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f158c174",
  null
  
)

export default component.exports